<div class="container-fluid bg-white rounded pt-1">
    <div *ngIf="!currentLogDetail">
        <list-header [viewLabel]="'LIST_HEADER_LABEL_USER_LOG' | translate" [showSyncProducts]="false"> </list-header>
        <tablelist [tableInfo]="tables['user'].tableInfo" (onHeaderClicked)="onHeaderClick($event, 'user')"></tablelist>
        <pagination [listInfo]="tables['user'].listInfo" (onPageChanged)="onPageChanged($event, 'user')"></pagination>
    </div>
    <div *ngIf="currentLogDetail">
        <button (click)="onBackClick()" class="btn px-3 py-1 mt-2 rounded btn-back">
            <span>{{ "HEADER_COMPONENT_LABEL_BACK" | translate }}</span>
        </button>
        <list-header [viewLabel]="'LIST_HEADER_LABEL_PHOTOSPHERE_LOG' | translate" [showSyncProducts]="false"> </list-header>
        <tablelist [tableInfo]="tables['photosphere'].tableInfo"></tablelist>
        <pagination
            [listInfo]="tables['photosphere'].listInfo"
            (onPageChanged)="onPageChanged($event, 'photosphere')"
        ></pagination>
        <list-header [viewLabel]="'LIST_HEADER_LABEL_PROMOTION_LOG' | translate" [showSyncProducts]="false"> </list-header>
        <tablelist [tableInfo]="tables['promotion'].tableInfo"></tablelist>
        <pagination
            [listInfo]="tables['promotion'].listInfo"
            (onPageChanged)="onPageChanged($event, 'promotion')"
        ></pagination>
        <list-header [viewLabel]="'LIST_HEADER_LABEL_PRODUCT_LOG' | translate" [showSyncProducts]="false"> </list-header>
        <tablelist [tableInfo]="tables['product'].tableInfo"></tablelist>
        <pagination [listInfo]="tables['product'].listInfo" (onPageChanged)="onPageChanged($event, 'product')"></pagination>
    </div>
</div>
